export default __webpack_public_path__ + "static/media/golden visa requirements.06ae232d.jpg";